<template>
  <div class="must">
    <ith-top-bar />
    <ith-banner :item="banner" />
    <ith-recommended-grid />
    <ith-footer />
  </div>
</template>

<script>
export default {
  name: "Recommended",
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Explore the must watch tv shows and top must watch movies at OTT Watchlist. These must watch inspirational movies will change your life before you know.",
      },
      {
        name: "keywords",
        content:
          "must watch tv shows, must watch movies, must watch inspirational movies",
      },
    ],
  },
  data: () => ({
    title: "Recommended",
    banner: {
      title: "",
      text: "",
      image: "./../../img/banners/RECOMMENDED.png",
    },
  }),
  created() {
    this.title = this.$router.params.slug;
    this.$store.commit("DISABLED_MENU");
    this.$store.commit("EDIT_CRITERIA", "");
  },

  methods: {},
};
</script>

<style scoped>
.must {
  background-color: #2c3848;
}
</style>
